import React, { Component } from "react";
import cnfg from "../tsConfig";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import { Backdrop } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WifiTetheringIcon from '@mui/icons-material/WifiTethering';
export class Search extends Component {
  constructor(props) {
    super(props);
    console.log("Search LOADING...");
    // get folders
    this.state = {
      arrFiles:[],
      folderPath: "",
      querystring: "",
      backDropState: false,
      backDropStateMsg: "Hämta filer...",
    };
    this.getFolders();
    this.renderFolderSelect = this.renderFolderSelect.bind(this);
    this.getAll = this.getAll.bind(this);
    this.searchIt = this.searchIt.bind(this);
    this.clearFiles = this.clearFiles.bind(this);
  }

  getFolders() {
    console.log("getting folders");
    this.setState({ backDropState: true });
    axios
      .post(
        cnfg.api + "/search/folders/",
        { key: "value" },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ users: res.data.folders });
          localStorage.setItem("folders", JSON.stringify(res.data.folders));
        } else {
          console.log("error in getting folders");
          console.log(res.data);
        }
        this.setState({ backDropState: false });
      })
      .catch((e) => {
        console.error("error in getting folders");
        console.error(e);
        alert("error in getting folders\n" + e);
        this.setState({ backDropState: false });
      });
  }
  keyValuePairFuncs(obj, prepend, res) {
    if (!obj) return res; // Added a null check for  Uncaught TypeError: Cannot convert undefined or null to object
    for (const [key, val] of Object.entries(obj)) {
      res.push(prepend + key);
      if (typeof val === "object") {
        this.keyValuePairFuncs(val, prepend + key + "/", res); // recursively call the function
      }
    }
    return res;
  }
  keyValuePairFuncsFiles(obj, prepend, res) {
    if (!obj) return res; // Added a null check for  Uncaught TypeError: Cannot convert undefined or null to object
    for (const [key, val] of Object.entries(obj)) {
      if (typeof val === "object") {
        this.keyValuePairFuncsFiles(val, prepend + key + "/", res); // recursively call the function
      } else if (typeof val === "string") {
        res.push(prepend + val);
      }
    }
    return res;
  }
  handleOnChange = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        console.log(
          "CHANGED...." + event.target.name + "//////////" + event.target.value
        );
        console.log(this.state);
      }
    );
  };
  clearFiles(){
    console.log('TIME TO CLEAR ALL FILES');
    // localStorage.removeItem("files");
    this.setState({files: []});
  }
  
  renderFiles() {
    // var ts = this.state;
    const filesPath = localStorage.getItem("filesPath");
    // const q = localStorage.getItem("q");
    var result1 = this.keyValuePairFuncsFiles(this.state.files, "", []);
    var html = '';
    if(result1.length){
      html = (
        <>
        <ol>
          {result1.map(function (data) {
            const x  = cnfg.docsUrl+filesPath+'/'+data;
            return (
              <li>
                <a href={x} target="_blank"  rel="noreferrer" >
                  {filesPath}/{data}  <OpenInNewIcon />
                 </a> 
              </li>
            );
          })}
        </ol>
        <button className="clearResults" onClick={this.clearFiles}>Ny sökning</button>
      </>
      );
    }else{
      html = (<ol><li>No Result / Search Again</li></ol>);
    }

    return html;
  }
  renderFolderSelect() {
    var ts = this.state;
    const arr = JSON.parse(localStorage.getItem("folders"));
    var result = this.keyValuePairFuncs(arr, "", []);
    var html = (
      <select name='folderPath' id='folderPath' onChange={this.handleOnChange}>
        <option value=''>Välj en mapp</option>
        {result.map(function (data) {
          if (ts.folderPath === data) {
            return (
              <option value={data} selected>
                {data}
              </option>
            );
          } else {
            return <option value={data}>{data}</option>;
          }
          // return <option value={data}>{data}</option>;
        })}
      </select>
    );
    return html;
  }
  getAll() {
    alert(
      "Work In Process\nThis Will fetch all pdfs files in folder\n" +
        this.state.folderPath
    );
  }
  searchIt() {
    // alert('Work In Process\nThis Will Search for ('+this.state.querystring+') in all pdfs files in folder\n'+this.state.folderPath);
    console.log("getting files");
    this.setState({ backDropState: true });
    axios
      .post(
        cnfg.api + "/search/files/",
        {
          q: this.state.querystring,
          path: this.state.folderPath,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ files: res.data.files });
          // localStorage.setItem("files", JSON.stringify(res.data.files));
          localStorage.setItem("filesPath", this.state.folderPath);
          localStorage.setItem("q", this.state.querystring);
        } else {
          console.log("error in getting files");
          console.log(res.data);
        }
        this.setState({ backDropState: false });
      })
      .catch((e) => {
        console.error("error in getting folders");
        console.error(e);
        alert("error in getting files\n" + e);
        this.setState({ backDropState: false });
      });
  }
  render() {
    return (
      <div className='tsSearch'>
        <h1>Sparade Ansökningar</h1>
        <h5>1: Välj mapp</h5>
        {this.renderFolderSelect()}

        {/* <h5>2: Get All PDF's In <strong>{this.state.folderPath}</strong></h5>
        <button onClick={this.getAll}>Get All PDF's</button> */}
        <h5>
          2: Sök SSN/PNR in <strong>{this.state.folderPath ? this.state.folderPath : '/'}</strong>
        </h5>
        <input
          placeholder='Lämna tomt för att hämta alla filer'
          type='text'
          className='searchText'
          value={this.state.querystring}
          name='querystring'
          id='querystring'
          onChange={this.handleOnChange}
        />
        <button className='searchIt' onClick={this.searchIt}>
          <SearchIcon />
        </button>
        {this.renderFiles()}
        <Backdrop open={this.state.backDropState}>
          <WifiTetheringIcon />
          {this.state.backDropStateMsg}
        </Backdrop>
      </div>
    );
  }
}

export default Search;
